import styles from './Footer.module.scss';

export function Footer() {
  return <footer hidden={true} className={styles.footer}></footer>;
}
